import { SequenceOption } from '@frontend/editor/interface';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { SEQUENCE_OPTION } from '../apis';

interface getSequenceOptionProps {
  projectID: string;
}

async function getSequenceOption({
  projectID,
}: getSequenceOptionProps): Promise<SequenceOption[]> {
  return axios
    .get(SEQUENCE_OPTION, {
      params: {
        projectId: projectID,
      },
    })
    .then((res) => res.data.data)
    .catch((err) => []);
}

export function useGetSequenceOption({ projectID }: getSequenceOptionProps) {
  return useQuery<SequenceOption[]>({
    queryKey: ['get-sequence-option', { projectID }],
    queryFn: () => {
      if (projectID) {
        return getSequenceOption({ projectID });
      } else {
        return [];
      }
    },
  });
}

export default useGetSequenceOption;
